import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevanbusonrent() {



    const cardData = {

keyword: "17 Seater Bus on Rent Pune",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable 17 Seater Bus on Rent in Pune for group travel, corporate tours, wedding transportation, school trips, pilgrimage journeys, and outstation travel across Maharashtra and India. Our well-maintained 17-seater buses come with comfortable push-back seats, air conditioning, spacious luggage storage, and experienced professional drivers for smooth highway journeys. With doorstep pickup across Pune, flexible rental packages, 24/7 support, and transparent pricing, we ensure a hassle-free and comfortable group travel experience for all occasions.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular weekend destinations near Pune, known for lush green valleys, waterfalls, misty hills, and scenic viewpoints. A 17-seater bus is perfect for large family groups, corporate outings, and school trips to enjoy monsoon drives and group sightseeing together in comfort."
    },
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool climate. It is ideal for large group travel, offering comfortable journeys for families, corporate teams, and school groups exploring nature and sightseeing attractions together."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. A 17-seater bus is widely used for group darshan tours, ensuring families and devotees can travel together comfortably for spiritual visits and blessings."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a spiritual and cultural hub known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. It is a popular group travel destination for religious tours, corporate outings, and family trips using 17-seater bus rentals from Pune."
    },
    {
        title: "Goa Beach Tour",
        description:
            "Goa is a long-distance vacation destination famous for beaches, nightlife, water sports, and scenic coastal roads. A 17-seater bus is ideal for large groups, friends, weddings, and corporate tours traveling together for a comfortable beach holiday experience."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. A 17-seater bus is commonly booked for group spiritual tours, offering comfort and coordination for family religious journeys from Pune."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular pilgrimage destination where a 17-seater bus ensures safe and comfortable travel for large groups and devotees."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. It is ideal for group outings, corporate trips, and family picnics using 17-seater bus rentals from Pune for a smooth coastal journey."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. It is a top destination for group heritage tours, educational trips, and cultural travel using 17-seater bus from Pune."
    },
    {
        title: "Konkan Coastal Trip",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, Harihareshwar, and Tarkarli is a scenic travel region. A 17-seater bus is perfect for long group vacations, offering comfort and space for beach tours from Pune through the Western Ghats."
    }
],



services: [
  {
    name: "17 Seater Bus on Rent Pune",
    description: "Rising Cab Service offers 17 Seater Bus on Rent Pune for family trips, corporate travel, weddings, pilgrimages, picnics, and outstation tours. Our well-maintained buses provide spacious seating, air conditioning, ample luggage space, and professional drivers. Whether you need transportation for a local event or a long-distance journey, we ensure safe, comfortable, and affordable travel with flexible rental packages and 24x7 booking support."
  },
  {
    name: "17 Seater Bus on Rent in Pune Price",
    description: "Get affordable 17 Seater Bus on Rent in Pune Price with transparent fare structures and no hidden charges. We provide customized rental packages based on distance, duration, and travel requirements while maintaining high standards of comfort and safety."
  },
  {
    name: "17 Seater Bus Rate Per Km in Pune",
    description: "Book a 17 Seater Bus Rate Per Km in Pune with budget-friendly pricing for local and outstation travel. Our transparent per-kilometer billing system ensures cost-effective transportation for family groups, corporate teams, and tourist travel."
  },
  {
    name: "17 Seater Bus on Rent in Pune",
    description: "Hire a 17 Seater Bus on Rent in Pune for comfortable group transportation. Our vehicles are ideal for weddings, educational tours, sightseeing trips, airport transfers, and outstation travel with experienced chauffeurs and reliable service."
  },
  {
    name: "17 Seater AC Tempo Traveller On Rent in Pune",
    description: "Book a 17 Seater AC Tempo Traveller On Rent in Pune for premium group travel. Enjoy fully air-conditioned interiors, comfortable pushback seats, spacious cabins, and professional drivers for local and long-distance journeys."
  },
  {
    name: "17 Seater Non AC Tempo Traveller on Rent in Pune",
    description: "Our 17 Seater Non AC Tempo Traveller on Rent in Pune offers an economical travel solution for groups. Perfect for budget-conscious travelers seeking reliable transportation for tours, events, and family outings."
  },
  {
    name: "17 Seater Tempo Traveller for Mahabaleshwar from Pune",
    description: "Hire a 17 Seater Tempo Traveller for Mahabaleshwar from Pune and enjoy a scenic hill station journey with spacious seating, professional drivers, and comfortable travel arrangements for families and groups."
  },
  {
    name: "17 Seater Tempo Traveller for Pune to Goa",
    description: "Book a 17 Seater Tempo Traveller for Pune to Goa and travel comfortably with your group. Our vehicles offer ample luggage space, AC comfort, and experienced drivers for long-distance coastal journeys."
  },
  {
    name: "17 Seater Tempo Traveller Pune to Nashik",
    description: "17 Seater Tempo Traveller Pune to Nashik service provides safe and convenient transportation for pilgrimages, corporate trips, and family tours with comfortable seating and reliable travel support."
  },
  {
    name: "17 Seater Tempo Traveller Pune to Mumbai Rent",
    description: "Choose 17 Seater Tempo Traveller Pune to Mumbai Rent for group travel between Pune and Mumbai. We offer punctual service, comfortable vehicles, and affordable rental packages."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Hadapsar",
    description: "Book 17 Seater Tempo Traveller on Rent in Hadapsar for local travel, family functions, corporate outings, and outstation tours. We provide clean vehicles and professional chauffeur service."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "Hire 17 Seater Tempo Traveller on Rent in Pimpri Chinchwad for group transportation with flexible rental plans, affordable pricing, and comfortable travel options."
  },
  {
    name: "17 Seater Tempo Traveller Hire in Viman Nagar",
    description: "17 Seater Tempo Traveller Hire in Viman Nagar offers convenient transportation for airport transfers, corporate travel, family outings, and long-distance trips with reliable service."
  },
  {
    name: "Pune to Shirdi 17 Seater Bus Booking",
    description: "Book Pune to Shirdi 17 Seater Bus Booking for Sai Baba darshan groups and family pilgrimages. Our service includes comfortable seating, experienced drivers, and affordable travel packages."
  },
  {
    name: "17 Seater Bus Hire Pune",
    description: "17 Seater Bus Hire Pune provides flexible transportation solutions for weddings, corporate events, educational tours, and sightseeing trips with well-maintained vehicles and professional drivers."
  },
  {
    name: "17 Seater Mini Bus on Rent Pune",
    description: "Hire a 17 Seater Mini Bus on Rent Pune for comfortable and economical group transportation. Ideal for family gatherings, social events, and outstation travel."
  },
  {
    name: "17 Seater Tempo Traveller Pune",
    description: "17 Seater Tempo Traveller Pune service offers spacious seating, air-conditioned comfort, and reliable transportation for local and long-distance journeys."
  },
  {
    name: "17 Seater Bus Rental Pune",
    description: "17 Seater Bus Rental Pune is suitable for corporate outings, wedding transportation, family vacations, and tourist travel with customized rental packages."
  },
  {
    name: "AC 17 Seater Bus on Rent Pune",
    description: "Book AC 17 Seater Bus on Rent Pune for comfortable travel in all seasons. Our air-conditioned vehicles provide a pleasant journey for groups traveling locally or outstation."
  },
  {
    name: "Luxury 17 Seater Bus Pune",
    description: "Luxury 17 Seater Bus Pune offers premium interiors, comfortable pushback seating, air conditioning, and modern amenities for VIP travel, weddings, and executive transportation."
  },
  {
    name: "17 Seater Bus Booking Pune",
    description: "17 Seater Bus Booking Pune allows quick reservations with transparent pricing, multiple travel options, and 24x7 customer support for all transportation needs."
  },
  {
    name: "Cheap 17 Seater Bus on Rent Pune",
    description: "Cheap 17 Seater Bus on Rent Pune provides affordable group transportation without compromising comfort, safety, or service quality. Ideal for budget-conscious travelers."
  },
  {
    name: "Outstation 17 Seater Bus Pune",
    description: "Outstation 17 Seater Bus Pune service is perfect for trips to Goa, Mahabaleshwar, Shirdi, Nashik, Mumbai, and other destinations with comfortable long-distance travel arrangements."
  },
  {
    name: "17 Seater Urbania on Rent Pune",
    description: "17 Seater Urbania on Rent Pune offers premium travel experience with luxury interiors, spacious seating, modern features, and superior comfort for group transportation."
  },
  {
    name: "17 Seater Traveller Hire Pune",
    description: "17 Seater Traveller Hire Pune provides reliable transportation for family tours, corporate events, weddings, and sightseeing trips with experienced chauffeurs and flexible rental plans."
  },
  {
    name: "Pune 17 Seater Bus Service",
    description: "Pune 17 Seater Bus Service caters to local and outstation travel requirements with professional drivers, well-maintained vehicles, and affordable pricing."
  },
  {
    name: "17 Seater Bus for Picnic Pune",
    description: "17 Seater Bus for Picnic Pune is ideal for school trips, family outings, corporate picnics, and weekend excursions with comfortable seating and safe transportation."
  },
  {
    name: "17 Seater Bus for Wedding Pune",
    description: "Book a 17 Seater Bus for Wedding Pune to transport guests conveniently and comfortably. We provide organized transportation with punctual pickups and professional service."
  },
  {
    name: "17 Seater Bus for Corporate Trip Pune",
    description: "17 Seater Bus for Corporate Trip Pune offers reliable transportation for team outings, conferences, business meetings, and employee travel with professional drivers and comfortable vehicles."
  },
  {
    name: "17 Seater Bus for Family Tour Pune",
    description: "17 Seater Bus for Family Tour Pune is designed for family vacations, pilgrimages, and holiday trips, providing spacious seating and comfortable travel for all passengers."
  },
  {
    name: "Pune to Goa 17 Seater Bus",
    description: "Pune to Goa 17 Seater Bus service offers comfortable long-distance transportation for beach holidays, group vacations, and corporate outings with experienced drivers and AC comfort."
  },
  {
    name: "17 Seater Tourist Bus Pune",
    description: "17 Seater Tourist Bus Pune provides dependable transportation for sightseeing tours, pilgrimage journeys, educational excursions, and leisure travel with complete comfort and safety."
  }
],

tableData: [
  ["17 Seater Bus on Rent Pune", "17 Seater Bus on Rent in Pune Price"],
  ["17 Seater Bus Rate Per Km in Pune", "17 Seater Bus on Rent in Pune"],
  ["17 Seater AC Tempo Traveller On Rent in Pune", "17 Seater Non AC Tempo Traveller on Rent in Pune"],
  ["17 Seater Tempo Traveller for Mahabaleshwar from Pune", "17 Seater Tempo Traveller for Pune to Goa"],
  ["17 Seater Tempo Traveller Pune to Nashik", "17 Seater Tempo Traveller Pune to Mumbai Rent"],
  ["17 Seater Tempo Traveller on Rent in Hadapsar", "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad"],
  ["17 Seater Tempo Traveller Hire in Viman Nagar", "Pune to Shirdi 17 Seater Bus Booking"],
  ["17 Seater Bus Hire Pune", "17 Seater Mini Bus on Rent Pune"],
  ["17 Seater Tempo Traveller Pune", "17 Seater Bus Rental Pune"],
  ["AC 17 Seater Bus on Rent Pune", "Luxury 17 Seater Bus Pune"],
  ["17 Seater Bus Booking Pune", "Cheap 17 Seater Bus on Rent Pune"],
  ["Outstation 17 Seater Bus Pune", "17 Seater Urbania on Rent Pune"],
  ["17 Seater Traveller Hire Pune", "Pune 17 Seater Bus Service"],
  ["17 Seater Bus for Picnic Pune", "17 Seater Bus for Wedding Pune"],
  ["17 Seater Bus for Corporate Trip Pune", "17 Seater Bus for Family Tour Pune"],
  ["Pune to Goa 17 Seater Bus", "17 Seater Tourist Bus Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Affordable 17 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable 17 Seater Bus rental services in Pune for family trips, corporate outings, weddings, school tours, pilgrimages, and group travel."
    },
    {
        WhyChooseheading: "Ideal for Small Group Transportation",
        WhyChoosedescription: "The 17 Seater Bus is perfect for family gatherings, office teams, tourist groups, educational trips, and social events requiring comfortable group travel."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "Our 17 Seater Buses are available for Pune city travel and outstation destinations including Mahabaleshwar, Shirdi, Goa, Lonavala, Nashik, Kolhapur, and Konkan tours."
    },
    {
        WhyChooseheading: "Comfortable Seating with Spacious Interiors",
        WhyChoosedescription: "Passengers enjoy comfortable seating arrangements, ample legroom, luggage space, and a smooth travel experience throughout the journey."
    },
    {
        WhyChooseheading: "AC and Non-AC Bus Options Available",
        WhyChoosedescription: "Customers can choose air-conditioned or non-air-conditioned 17 Seater Buses based on travel requirements and budget preferences."
    },
    {
        WhyChooseheading: "Pickup Service Across Pune & PCMC",
        WhyChoosedescription: "Bus pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Group Travel",
        WhyChoosedescription: "Experienced drivers ensure safe driving, punctual service, and smooth transportation for family tours, corporate trips, and sightseeing journeys."
    },
    {
        WhyChooseheading: "Perfect for Tours, Events, and Pilgrimages",
        WhyChoosedescription: "The 17 Seater Bus is widely preferred for Ashtavinayak tours, Shirdi trips, weddings, corporate events, school excursions, and weekend getaways."
    }
]
};

const faqData = [
    {
        question: "What is a 17 Seater Bus on Rent in Pune?",
        answer: "A 17 Seater Bus rental service provides comfortable transportation for groups of up to 17 passengers for local and outstation travel."
    },
    {
        question: "Can I hire a 17 Seater Bus for outstation trips?",
        answer: "Yes, 17 Seater Buses are available for destinations across Maharashtra and various cities throughout India."
    },
    {
        question: "Are AC 17 Seater Buses available?",
        answer: "Yes, both AC and Non-AC 17 Seater Bus options are available depending on customer preferences."
    },
    {
        question: "Can families hire a 17 Seater Bus for vacations?",
        answer: "Yes, the vehicle is ideal for family holidays, sightseeing tours, weekend trips, and group travel."
    },
    {
        question: "Do you provide 17 Seater Buses for pilgrimage tours?",
        answer: "Yes, buses are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga tours, and other religious destinations."
    },
    {
        question: "Can companies hire a 17 Seater Bus for corporate events?",
        answer: "Yes, businesses regularly use these buses for employee transportation, team outings, conferences, and corporate travel."
    },
    {
        question: "Is luggage space available in the bus?",
        answer: "Yes, the vehicle offers sufficient luggage space for passengers during outstation and long-distance journeys."
    },
    {
        question: "Can I book the bus for wedding guest transportation?",
        answer: "Yes, 17 Seater Buses are commonly hired for weddings, family functions, and social gatherings."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, bus pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a 17 Seater Bus on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ganesh Kulkarni",
        feedback:
            "We hired a 17 Seater Bus for our Ashtavinayak pilgrimage tour. The vehicle was comfortable, the driver was professional, and the entire group enjoyed a smooth journey.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Patil",
        feedback:
            "Our family outing to Mahabaleshwar was perfectly managed with the 17 Seater Bus. The seating was spacious, and everyone traveled comfortably throughout the trip.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "17 Seater Bus on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/17-seater-tempo-traveller-pune.jpg",
"description": "Book 17 Seater Bus on Rent in Pune with Rising Cab Service for group travel, corporate tours, weddings, and outstation trips. Comfortable AC tempo traveller with experienced driver for safe and reliable journeys.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹24/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/17-seater-bus-on-rent-pune"
}
};





    return (
        <div>


<Helmet>
  <title>17 Seater Bus on Rent in Pune | Tempo Traveller Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book 17 Seater Bus on Rent in Pune for group travel, corporate tours, weddings, and outstation trips. Get AC tempo traveller with driver for safe and comfortable journeys."
/>

<meta
 name="keywords"
 content="17 seater bus on rent pune, 17 seater bus on rent in pune price, 17 seater bus rate per km in pune, 17 seater tempo traveller pune, 17 seater bus hire pune, group travel bus pune, tempo traveller 17 seater pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onesevanbusonrent;